var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1187_3345)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 256,
    fill: "url(#pattern0_1187_3345)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1187_3345",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1187_3345",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1187_3345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1187_3345",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAIAAABt+uBvAAAAA3NCSVQICAjb4U/gAAAEV0lEQVR4nO2bT0hcRxzHf7+3+3aVpqZCm61uUvQijQmIjR5KoCKUkJMEc/EghbQbCJGGIEl7aU8eQw5iPKTQQ5u2UNDWm1CSovQY8qfmsqUE1ta4iUalBMTN2/cmhy3Dsv9+6s7Mmw2/z2mf897M8Nn5vpk3+8TJUwKY6jhhd8B2WBABCyJgQQQsiIAFEbAgAhZEwIIIWBABCyJgQQQsiIAFEbAgAhZEwIIIWBABCyKIGmsJ0VRLAhRus5sQhACB8F7k1gD1D1gRxKMH45EDqhxpF4QAAXjfPzx3f/1H3W0VuNg7f/TQaaHIkF5BCIAI394debT5i9aGinEcV2VtCusqAREC8L65e9akHeXoGkGF+86tB58W2xkdHU2lUvl8XnFbiOvr6yMjI2qrLaBFULVkdXV1DQwM6GhxbW1NR7WgI2I1kuX7vvLmdNesWFDFZDU0KiMWypylG2UjCAHyYqfR56xylI0gRHj8/I867Yii5R2WPZvULtWE0ojV12khxNjYWCaTCYKgv79/YmKi5ISZmZnp6emWlpalpaV0Ot3U1FRPc7tE7TRf77eayWTm5+cBoKOjo7x0e3t7cXGxzib2il3bHdHo/1+Y41TomLFYFWOXIAthQQQsiIAFEbAgAhZEwIII7BK0vLxc+LC1tVVemsvl5Gehas+ZwtzPPiSIODc3FwQBALhuhX3loaGhwcFBRPR9Px6Pm+mVRYIAoLOzs0ZpIpFIJBLGOlPArojtG/mMopzXRNAP3/2sqebXQdDU5M3xq5/Lw0B4CitveEHXr01dunxBHiab+zpaP1Q4xdl1k94r169NXfnikjx8y+0cP7kQi7wRqBPUwCNoavJmiZ2vPvrTVWoHGldQebK+HngUi76pfP1oVFDFfcJ9UC1ZOlbXRu9B2Ww2nU57Xuks4/t+d3d3LBYr/uPGxtbKyj8lTiORyO3fFgwkS4Kq/uvZQfjr+Z0b9z7e3+Wbm5utra3yMLv6rD35LnlVsrlv/OSCq2fsFLDlHlS8Ib/yb3Y3drQmS2KLIEl29dmR99rJ03QnS2KXoN0nS9OcVY4tglw3uvrkqT3JktgiaDmzkjzcRp5mLFkSWwQdO36UPMdksiS2CCIxnCxJYwgynyyJWkFauh9KsiQqHzWiTuxIc/+B2DsVSxHR83f+fnGn2uXvHzyNECm2LCBw0P2s7ye1Oxh7QtmjBgBEECLVRyQi/Lez8eXvb1csTfXM9iWHy8eIAMj7ekbm7lA5gnwBNd7GRQQveFmxKNUze6J9OKf4/XI1hL+jeL7n1962My91vedcLyHPYqme2d62M14Qbi9qEaagQrJstgMhRszyZEnCGUH2J0tiVpAQ0CDJkhgV5Avvk+O3Pmgbtj9ZEpULRZJAeFHHDWtNvD/M/uyDDWYHQl8H2Q8LImBBBCyIgAURsCACFkTAgghYEAELImBBBCyIgAURsCACFkTAgghYEAELImBBBCyI4BX8FGwYcDQz1gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.4c12166b09fbd7ae7c73244637c3798a.svg";
export { ForwardRef as ReactComponent };